// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"apps_ofplatform_ofassembler_src_bootstrap_tsx":"4487b81e7af6cddf500c","apps_ofplatform_ofassembler_src_app_app_tsx":"8b2dee7cda9bc381a60d"}[chunkId] + ".css";
};